import { BoltIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function CreditsBadge({ credits }) {
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();

  // Scale animation on updates
  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 500);
    return () => clearTimeout(timer);
  }, [credits]);

  // Color scheme
  const getColor = () => {
    if (credits < 100) return "bg-red-600 text-white"; // critical
    if (credits < 500) return "bg-amber-400 text-black"; // warning
    return "bg-emerald-100 text-emerald-800"; // safe
  };

  // Blinking only when critical
  const getPulse = () => (credits < 100 ? "animate-pulse" : "");

  // Redirect to wallet only when credits are low
  const handleClick = () => {
    if (credits < 500) navigate("/dashboard/wallet");
  };

  const clickable = credits < 500;

  return (
    <div
      className={`relative group ${
        clickable ? "cursor-pointer" : "cursor-default"
      }`}
      onClick={handleClick}
    >
      <span
        className={`
          inline-flex items-center gap-1
          px-3 py-1.5 text-sm font-semibold rounded-full shadow-md
          transition-all duration-300
          ${getColor()}
          ${animate ? "scale-110" : "scale-100"}
          ${getPulse()}
          ${clickable ? "hover:shadow-lg" : ""}
        `}
      >
        <BoltIcon aria-hidden="true" className="h-5 w-5" />
        {credits}
      </span>

      {/* Tooltip */}
      <div
        className="
          absolute left-1/2 -translate-x-1/2 mt-2
          hidden group-hover:block
          bg-gray-900 text-white text-xs
          px-2 py-1 rounded shadow-lg whitespace-nowrap
        "
      >
        {credits < 100
          ? "Critically low — recharge now"
          : credits < 500
          ? "Low credits — click to top up"
          : `Credits: ${credits}`}
      </div>
    </div>
  );
}
